"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSingleArgFnCondition = void 0;
const parseSingleArgFnCondition = (conditionParser, condition) => {
    const attributePath = condition.attr;
    conditionParser.resetExpression(`${condition.exists === true ? 'attribute_exists' : 'attribute_not_exists'}(`);
    conditionParser.appendAttributePath(attributePath);
    conditionParser.appendToExpression(')');
};
exports.parseSingleArgFnCondition = parseSingleArgFnCondition;
